export const DEMANDVSSUPPLY_REPORT_ACTION = 'DEMANDVSSUPPLY_REPORT_ACTION'
export const DEMANDVSSUPPLY_REPORT_ACTION_SUCCESS = 'DEMANDVSSUPPLY_REPORT_ACTION_SUCCESS'
export const DEMANDVSSUPPLY_REPORT_ERROR_ACTION = 'DEMANDVSSUPPLY_REPORT_ERROR_ACTION'

